import React from 'react'
import PopUp from './components/partials/Notifications/PopUp'
import { useRouteError } from 'react-router-dom'
import * as Sentry from '@sentry/react'

export default function ErrorBoundaryRouter () {
  const error = useRouteError()
  let errorMessage = 'An error in the application has occurred. Please click the link below to go back to the home page.'
  if (import.meta.env.DEV) {
    errorMessage += `\n\n${error.statusText || error.message}`
    console.error(error)
  } else {
    // Send error to Sentry
    Sentry.captureException(error)
  }

  return (
    <PopUp
      visible
      text={errorMessage}
      textButton='Home'
      functionButton={() => {
        window.location.href = '/'
      }}
    />
  )
}
